export enum UserRoleEnum {
  ADMIN = "admin",
  DOCTOR = "doctor",
  SCAN_CENTER = "scan_center",
  REFERRING_DOCTOR = "referring_doctor",
}
